module.exports = __webpack_public_path__ + "img/street_light.906eeca0.svg";